import React, { ButtonHTMLAttributes } from 'react';

import { Button as StyledButton } from './styles';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>{
  defaultColor?: string;
  hoverColor ?: string;
};

const Button: React.FC<ButtonProps> = ({ children, ...rest }) => {
  return <button className='defaultButton' style={{margin: '10px auto'}} {...rest}>{children}</button>;
};

export default Button;
